"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _blocks = require("@bueno/blocks");

var _Site = require("./Site.styles");

const SelectedSite = ({
  label,
  onClick,
  noMatch
}) => /*#__PURE__*/React.createElement(_Site.$SelectedSite, {
  type: "button",
  title: label,
  onClick: onClick,
  noMatch: noMatch
}, /*#__PURE__*/React.createElement("span", {
  className: "Site-label"
}, label), /*#__PURE__*/React.createElement(_blocks.Remove, {
  tiny: true,
  fillColor: _blocks.color.theme.icon.default
}));

var _default = SelectedSite;
exports.default = _default;
module.exports = exports.default;